import _ from "lodash";

export const generateSheetOptions = ({
  sheets,
}: {
  sheets?: Array<string>;
}) => {
  if (!_.isNil(sheets)) {
    return sheets?.map((sheet) => ({
      value: sheet,
      label: sheet,
    }));
  } else {
    return [];
  }
};

export const generateRowOptions = () => {
  return Array.from({ length: 301 }, (_, i) => (i + 1).toString());
};

const generateColumnOptions = () => {
  const columns: Array<string> = [];

  // Helper function to generate column names
  const getColumnName = ({ n }: { n: number }): string => {
    let result = "";
    while (n > 0) {
      n--; // Decrement to make it 0-indexed
      result = String.fromCharCode(65 + (n % 26)) + result;
      n = Math.floor(n / 26);
    }
    return result;
  };

  // Generate columns from 1 to the maximum required ("ZZZ")
  for (let i = 1; i <= 702; i++) {
    // 16384 is the number of columns from "A" to "ZZZ"
    const columnName = getColumnName({ n: i });
    columns.push(columnName);
  }

  return columns;
};

export const COLUMN_OPTIONS = generateColumnOptions();
export const ROW_OPTIONS = generateRowOptions();
